__turbopack_context__.v({
  "article": "NewsArticleBody-module-scss-module__TdVnta__article",
  "richText": "NewsArticleBody-module-scss-module__TdVnta__richText",
  "richTextGlowEnd": "NewsArticleBody-module-scss-module__TdVnta__richTextGlowEnd",
  "richTextGlowStart": "NewsArticleBody-module-scss-module__TdVnta__richTextGlowStart",
});
